import {
  createActions 
} from "redux-actions";

const prefix = "USER";
const actionTypes = ["RESET", "SET_TOKEN", "CLEAR_TOKEN", "TOGGLE_SHOW_AUTH_DIALOG", "TOGGLE_CREATE_ACCOUNT_SUCCESS_COUPON_SHOW", "TOGGLE_CURRENT_AUTH_DIALOG"];

const actionMap = {
  SIGN_IN: {
    REQUEST: null,
    RECEIVE: null
  },
  GET_DETAILS: {
    REQUEST: null,
    RECEIVE: null
  },
  CREATE_ACCOUNT: {
    REQUEST: null,
    RECEIVE: null
  },
  RESET_PASSWORD: {
    REQUEST: null,
    RECEIVE: null
  }
};

export default createActions(actionMap, ...actionTypes, {
  prefix 
});
